import { createContext, useContext, useState, ReactNode } from 'react'

interface ShippingContextType {
  testMode: boolean
  setTestMode: (value: boolean) => void
  // Callback para navegar a la pestaña de tracking
  navigateToTracking: (() => void) | null
  setNavigateToTracking: (fn: (() => void) | null) => void
  // IDs de envíos para imprimir etiquetas combinadas
  shipmentIdsToPrint: number[]
  setShipmentIdsToPrint: (ids: number[]) => void
}

const ShippingContext = createContext<ShippingContextType | undefined>(undefined)

export function ShippingProvider({ children }: { children: ReactNode }) {
  // Por defecto en modo test para seguridad
  const [testMode, setTestMode] = useState(true)
  // Callback para navegación
  const [navigateToTracking, setNavigateToTracking] = useState<(() => void) | null>(null)
  // IDs de envíos para imprimir
  const [shipmentIdsToPrint, setShipmentIdsToPrint] = useState<number[]>([])

  return (
    <ShippingContext.Provider value={{
      testMode,
      setTestMode,
      navigateToTracking,
      setNavigateToTracking,
      shipmentIdsToPrint,
      setShipmentIdsToPrint
    }}>
      {children}
    </ShippingContext.Provider>
  )
}

export function useShippingContext() {
  const context = useContext(ShippingContext)
  if (context === undefined) {
    throw new Error('useShippingContext must be used within a ShippingProvider')
  }
  return context
}
